import SubmissionBlock from './SubmissionBlock.jsx';
import EditBlock from './EditBlock.jsx';
import ImpactBlock from './ImpactBlock.jsx';

/**
 * Train Me detail body: submission (current vs proposed), editable value, then
 * impact. Promote / Reject stay in the sticky decision footer.
 */
function TrainMeBody({ event }) {
  const detail = event.detail ?? {};
  return (
    <div className="flex flex-col gap-5">
      <SubmissionBlock detail={detail} />
      <EditBlock detail={detail} />
      <ImpactBlock impact={detail.impact} />
    </div>
  );
}

export default TrainMeBody;
